// John Eldhose 20190612
import { RestfulGet } from './Restful';

export async function getRMAs() {
  const rma = await RestfulGet('getRMAs', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return rma;
}



// WEBPACK FOOTER //
// ./src/Api/getRMAs.js